module.exports = __webpack_public_path__ + "static/media/hambuger.72f574ee.svg";